import { setOptions, importLibrary } from '@googlemaps/js-api-loader'

export { importLibrary }

export default {
  created() {
    setOptions({
      apiKey: process.env.VUE_APP_MAPS_API_KEY,
      version: 'weekly',
    })
  },
}
